<button fxLayout="row" fxLayoutAlign="start center" class="w-100-p" mat-menu-item (click)="onClickButton($event)" [disabled]="disabled">
    <mat-icon class="mr-12" *ngIf="icon">{{ icon }}</mat-icon>
    <mat-icon class="mr-12" *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

    <span class="text-sm text-wrap menu-item-label">{{ label | translate }}<span *ngIf="showThreeDots">...</span></span>
    <ng-container *ngIf="endIcon || endSvgIcon">
        <span class="menu-item-spacer"></span>
        <span class="menu-item-end-icon-container">
            <mat-icon class="menu-item-end-icon" *ngIf="endIcon">{{ endIcon }}</mat-icon>
            <mat-icon class="menu-item-end-icon" *ngIf="endSvgIcon" [svgIcon]="endSvgIcon"></mat-icon>
        </span>
    </ng-container>
</button>
